import { parseApiDate } from '@propertypal/shared/src/services/dayjs';
import React, { CSSProperties, useRef } from 'react';
import { CalendarDay, CalendarMonth, Container, Icon } from './CalenderIcon.style';

export interface CalendarIconProps {
  date: string;
  mode: 'black' | 'white';
  containerStyle?: CSSProperties;
}

const CalendarIcon: React.FC<CalendarIconProps> = (props) => {
  const date = useRef(parseApiDate(props.date));

  return (
    <Container style={props.containerStyle}>
      <Icon mode={props.mode} />
      <CalendarMonth mode={props.mode}>{date.current.format('MMM')}</CalendarMonth>
      <CalendarDay mode={props.mode}>{date.current.format('DD')}</CalendarDay>
    </Container>
  );
};

export default CalendarIcon;
